export const CAPITULOS_CYPE = [
  { id: "0", nombre: "Actuaciones previas" },
  { id: "D", nombre: "Demoliciones" },
  { id: "A", nombre: "Acondicionamiento del terreno" },
  { id: "C", nombre: "Cimentaciones" },
  { id: "E", nombre: "Estructuras" },
  { id: "F", nombre: "Fachadas y particiones" },
  { id: "Q", nombre: "Cubiertas" },
  { id: "N", nombre: "Aislamientos e impermeabilizaciones" },
  { id: "I", nombre: "Instalaciones" },
  { id: "L", nombre: "Carpintería, vidrios y protecciones solares" },
  { id: "R", nombre: "Revestimientos y trasdosados" },
  { id: "S", nombre: "Señalización y equipamiento" },
  { id: "H", nombre: "Remates y ayudas" },
  { id: "U", nombre: "Urbanización interior de la parcela" },
  { id: "J", nombre: "Jardinería" },
  { id: "T", nombre: "Equipamientos deportivos y urbanos" },
  { id: "M", nombre: "Mobiliario y pavimentos urbanos" },
  { id: "X", nombre: "Control de calidad y ensayos" },
  { id: "Y", nombre: "Seguridad y salud" },
  { id: "G", nombre: "Gestión de residuos" },
  { id: "Z", nombre: "Rehabilitación energética" },
];

const ORDEN_POR_ID = new Map(CAPITULOS_CYPE.map((c, i) => [c.id, i]));
const NOMBRE_POR_ID = new Map(CAPITULOS_CYPE.map((c) => [c.id, c.nombre]));
const CAPITULO_OTROS = { id: "OTROS", nombre: "Otros", orden: 9999 };

export function capituloDeCodigo(jobcardId) {
  if (!jobcardId) return CAPITULO_OTROS;
  const m = String(jobcardId).match(/^([0-9A-Z])/i);
  if (!m) return CAPITULO_OTROS;
  const letra = m[1].toUpperCase();
  const nombre = NOMBRE_POR_ID.get(letra);
  if (!nombre) return CAPITULO_OTROS;
  return { id: letra, nombre, orden: ORDEN_POR_ID.get(letra) ?? 9999 };
}

export function jobcardIdDeLinea(linea) {
  if (!linea) return null;
  if (linea.jobcard_id) return linea.jobcard_id;
  if (typeof linea.area === "string") {
    const partes = linea.area.split("_").filter(Boolean);
    if (partes[0] === "extra" && partes.length >= 3) {
      const base = partes[2];
      return base ? base.toUpperCase() : null;
    }
  }
  return null;
}

export function esLineaSugerida(linea) {
  return typeof linea?.area === "string" && linea.area.startsWith("extra_");
}

export function ordenarLineasConCapitulos(lineas) {
  return [...lineas]
    .map((l, idx) => ({ l, idx }))
    .sort((a, b) => {
      const capA = capituloDeCodigo(jobcardIdDeLinea(a.l));
      const capB = capituloDeCodigo(jobcardIdDeLinea(b.l));
      if (capA.orden !== capB.orden) return capA.orden - capB.orden;
      const sugA = esLineaSugerida(a.l) ? 1 : 0;
      const sugB = esLineaSugerida(b.l) ? 1 : 0;
      if (sugA !== sugB) return sugA - sugB;
      return a.idx - b.idx;
    })
    .map((entry) => entry.l);
}

export function agruparLineasPorCapitulo(lineas) {
  const ordenadas = ordenarLineasConCapitulos(lineas);
  const grupos = [];
  const indice = new Map();
  for (const l of ordenadas) {
    const cap = capituloDeCodigo(jobcardIdDeLinea(l));
    let g = indice.get(cap.id);
    if (!g) {
      g = { capitulo: cap, lineas: [] };
      grupos.push(g);
      indice.set(cap.id, g);
    }
    g.lineas.push(l);
  }
  return grupos;
}
